import { render, staticRenderFns } from "./SensitiveWords.vue?vue&type=template&id=4f2446ac&scoped=true&"
import script from "./SensitiveWords.vue?vue&type=script&lang=js&"
export * from "./SensitiveWords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2446ac",
  null
  
)

export default component.exports